export default __webpack_public_path__ + "img/8e0507a4a18b6e423509a77bd6f3818a.svg";